import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ClientTypeService', ClientTypeService);

  ClientTypeService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'ClientTypeModalService',
  ];

  function ClientTypeService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    ClientTypeModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'client_types';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getClientTypes: getClientTypes,
      getClientType: getClientType,
      saveClientType: saveClientType,
      deleteClientType: deleteClientType,
      changeClientTypeStatus: changeClientTypeStatus,
      changeClientTypeDefault: changeClientTypeDefault,
      openClientTypesModal: openClientTypesModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getClientTypes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getClientType(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveClientType(item, language) {
      function success(response) {
        var msg = item.id ? 'MODIFIED_CLIENT_TYPE' : 'NEW_ADDED_CLIENT_TYPE';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      item.lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      return RestResource.request(method, url, item, success, failure);
    }

    function deleteClientType(item, successCallback) {
      var params = {
        title: 'SURE_TO_DELETE_CLIENT_TYPE',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DELETED_CLIENT_TYPE',
      };

      var url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeClientTypeStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function changeClientTypeDefault(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.predefined = true;

      var params = {
        client_type: {
          predefined: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_CLIENT_TYPE_CHANGED');
        utils._successMsg(msg);

        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function openClientTypesModal(getItemsCallback) {
      ClientTypeModalService.openClientTypes(getItemsCallback);
    }
  }
})();
